import { useSyncExternalStore } from 'react';

import { useIsLoggedIn } from 'src/app/graph/hooks/useIsLoggedIn';

import {
  type Consent,
  FULL_CONSENT,
  onConsentChange,
  parseConsent,
} from './consent';

// a string snapshot, because useSyncExternalStore compares by reference
const getActiveGroups = () => window.OnetrustActiveGroups ?? '';

/**
 * Which tracking categories the current visitor allows. Logged in users allow
 * everything; everyone else, including while login state is still loading,
 * allows what they chose in the OneTrust banner.
 */
export const useConsent = (): Consent => {
  const { isLoggedIn } = useIsLoggedIn();
  const activeGroups = useSyncExternalStore(onConsentChange, getActiveGroups);

  if (isLoggedIn) return FULL_CONSENT;
  return parseConsent(activeGroups, navigator.globalPrivacyControl);
};
